import { atom } from "recoil";

export const workspacesMessagesList = atom({
  key: "workspacesMessages",
  default: [],
});
